// Estado vacío / sin resultados
export default function EmptyState({ title = 'Keine Ergebnisse', message, children }) {
  return (
    <div className="state-block state-empty">
      <div className="state-icon" aria-hidden="true">🔍</div>
      <h2>{title}</h2>
      {message && <p>{message}</p>}
      {children}
    </div>
  )
}
